import { ViewFactory, ComponentManager } from 'radpresentation.htmlclient.defaultviewextensions';


import ONVStatisticView from './ONVStatisticView';
import ONVStatisticViewModel from './ONVStatisticViewModel';

class ONVStatisticViewFactory extends ViewFactory {
    private readonly ONVStatisticViewModel: typeof ONVStatisticViewModel;
    private readonly StatisticView: typeof ONVStatisticView;

    constructor(params: any) {
        super(params);
        this.ONVStatisticViewModel = ComponentManager.getViewModel<typeof ONVStatisticViewModel>('ONVStatisticViewModel');
        this.StatisticView = ComponentManager.getView<typeof ONVStatisticView>('ONVStatisticView');
    }

    public getView(): JQuery<HTMLElement> {
        this.resolveDependencies(['Wireframe']);
        
        if (this.viewModel == null || this.viewModel.isDisposed) {
            this.viewModel = new this.ONVStatisticViewModel({ viewFactory: this });
        }
        if (this.view == null) {
            this.view = new this.StatisticView(this.viewModel, this.createRootElement('ONVStatistic'));
        }
        this.setPageTitle('Statistik');
        return this.view.getTuple().view;
    }
}

ComponentManager.setFactory('ONVStatistic', ONVStatisticViewFactory, 'ONVHTMLViewExtension');
export default ONVStatisticViewFactory;